import React, {useState} from 'react';
import {Dialog} from '../dialog/Dialog';
import {ButtonBase} from '../elements';
import styled from "styled-components";
import {SearchComponent} from "./SearchComponent";
import {useTranslation} from "react-i18next";

const CloseKeyWrapper = styled.div`
    background-color: #2B3036;
    border: 2px solid #449CFA; 
    border-radius: 15px;
    color: #4592E6; 
    font-family: Roboto; 
    font-size: 24px; 
    letter-spacing: 0;
`;
CloseKeyWrapper.displayName = 'CloseKeyWrapper';

const CloseKeyButtonBase = styled(ButtonBase)`
        height: 56px; 
    width: 216px; 
    border-radius: 15px;
    padding-left: 37px;
    padding-right: 37px;
` as typeof ButtonBase;


interface SearchModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
}

export function SearchModal(props: SearchModalProps) {
    const [char, addChar] = useState<string>('');
    const {t} = useTranslation();

    function handleClose() {
        props.setOpen(false);
    }


    React.useEffect(()=>{
        addChar('');
    },[]);


    return (
        <Dialog isOpen={props.open} onClose={handleClose}>
            <div className={"bg-[initial] shadow-[initial] overflow-y-[unset] w-min-[1040px] bg-[#373e44] !top-[70px] w-full h-full"}>
                <SearchComponent char={char} setOpen={props.setOpen}>
                    <CloseKeyWrapper onClick={handleClose}>
                        <CloseKeyButtonBase aria-label={'Keyboard search backspace'}>
                            {t("close")}
                        </CloseKeyButtonBase>
                    </CloseKeyWrapper>
                </SearchComponent>
            </div>
        </Dialog>
    );
}
